import React, { ReactElement } from "react"
import classnames from "classnames"

import * as styles from "./AboutBody.module.css"
import HoverShadow from "../MdxShortCodes/HoverShadow"
import { TextColors } from "../../templates/mdx.layout"
import { Link } from "gatsby"
import AboutImage from "./AboutImage"

const AboutBody = ({
  children,
  image,
}: {
  children: ReactElement
  image: string
}) => {
  return (
    <div className={classnames(styles.aboutBodyContainer, "fancy-scroll")}>
      <AboutImage image={image} />
      <div>
        <div className={styles.aboutBody}>{children}</div>
        <div className={styles.links}>
          <div>
            <span>How Can We Help?</span>
            <TextColors.Secondary>
              <HoverShadow>
                <Link to="/customer/">
                  <h1>Customer Experience</h1>
                </Link>
              </HoverShadow>
            </TextColors.Secondary>

            <TextColors.Primary>
              <HoverShadow>
                <Link to="/employee/">
                  <h1>Employee Experience</h1>
                </Link>
              </HoverShadow>
            </TextColors.Primary>
          </div>
          <div className={styles.image}>
            <img
              src={image}
              alt="About Press'nXPress Customer Feedback Platform"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutBody
